import React, { Component } from 'react';
import { ArrowRight, Check, Eye, EyeOff, LockKeyhole, Mail, ShieldCheck } from 'lucide-react';
import LoginService from '../serivces/loginService';
import './LoginPage.css';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.service = new LoginService();
    }

    state = {
        model: { user: '', pass: '' },
        isLoginFailed: false,
        errors: {},
        showPassword: false,
        isSubmitting: false,
    };

    onChange = (ev) => {
        const { name, value } = ev.target;
        this.setState((state) => ({
            model: { ...state.model, [name]: value },
            errors: { ...state.errors, [name]: '' },
            isLoginFailed: false,
        }));
    };

    validate = () => {
        const { user, pass } = this.state.model;
        const errors = {};
        if (!user.trim()) errors.user = 'Vui lòng nhập tài khoản hoặc email.';
        if (!pass) errors.pass = 'Vui lòng nhập mật khẩu.';
        this.setState({ errors });
        return Object.keys(errors).length === 0;
    };

    login = (ev) => {
        ev.preventDefault();
        if (!this.validate()) return;

        this.setState({ isSubmitting: true, isLoginFailed: false });
        this.service.login(this.state.model)
            .then((rs) => {
                if (!rs.success) {
                    this.setState({ isLoginFailed: true, isSubmitting: false });
                    return;
                }
                this.service.setToken(rs.token);
                this.props.onLoginCompleted(true);
            })
            .catch(() => this.setState({ isLoginFailed: true, isSubmitting: false }));
    };

    render() {
        const { errors, isLoginFailed, isSubmitting, model, showPassword } = this.state;

        return (
            <main className="workplace-login">
                <div className="workplace-ribbon">THACO AGRI WORKPLACE • PHÁT TRIỂN BỞI BAN CNTT THACO AGRI</div>

                <section className="workplace-login-layout" aria-labelledby="login-title">
                    <aside className="workplace-login-brand">
                        <div className="workplace-brand-lockup">
                            <img src="/img/thaco-agri-logo.png" alt="THACO AGRI" />
                            <span aria-hidden="true" />
                            <strong>Workplace</strong>
                        </div>

                        <div className="workplace-login-story">
                            <span className="workplace-kicker">KHÔNG GIAN LÀM VIỆC SỐ</span>
                            <h1>Một điểm truy cập.<br />Mọi công việc hằng ngày.</h1>
                            <p>Toàn bộ ứng dụng dùng chung của THACO và các nền tảng chuyên ngành THACO AGRI được kết nối trên một không gian thống nhất.</p>

                            <div className="workplace-login-values">
                                <div><span><Check size={18} /></span><strong>Đăng nhập một lần</strong><small>Dùng tài khoản THACO AGRI</small></div>
                                <div><span><ShieldCheck size={18} /></span><strong>Đúng quyền, đúng vai trò</strong><small>Quản trị truy cập tập trung</small></div>
                                <div><span><LockKeyhole size={18} /></span><strong>An toàn khi thay đổi nhân sự</strong><small>Thu hồi quyền kịp thời</small></div>
                            </div>
                        </div>

                        <div className="workplace-field-art" aria-hidden="true">
                            <span className="workplace-sun" />
                            <span className="workplace-field workplace-field-one" />
                            <span className="workplace-field workplace-field-two" />
                            <span className="workplace-field workplace-field-three" />
                        </div>
                    </aside>

                    <section className="workplace-login-panel">
                        <form className="workplace-login-card" onSubmit={this.login} noValidate>
                            <div className="workplace-mobile-brand">
                                <img src="/img/thaco-agri-logo.png" alt="THACO AGRI" />
                                <span aria-hidden="true" />
                                <strong>Workplace</strong>
                            </div>

                            <span className="workplace-eyebrow">CHÀO MỪNG TRỞ LẠI</span>
                            <h2 id="login-title">Đăng nhập Workplace</h2>
                            <p>Sử dụng tài khoản THACO AGRI để truy cập các ứng dụng được cấp quyền.</p>

                            <label htmlFor="username">Tài khoản hoặc email</label>
                            <div className={`workplace-input ${errors.user ? 'has-error' : ''}`}>
                                <Mail size={18} aria-hidden="true" />
                                <input id="username" name="user" type="text" autoComplete="username" placeholder="tennguoidung@thacoagri.com.vn" value={model.user} onChange={this.onChange} aria-invalid={Boolean(errors.user)} />
                            </div>
                            <p className="workplace-field-error" role="alert">{errors.user}</p>

                            <label htmlFor="password">Mật khẩu</label>
                            <div className={`workplace-input ${errors.pass ? 'has-error' : ''}`}>
                                <LockKeyhole size={18} aria-hidden="true" />
                                <input id="password" name="pass" type={showPassword ? 'text' : 'password'} autoComplete="current-password" placeholder="Nhập mật khẩu" value={model.pass} onChange={this.onChange} aria-invalid={Boolean(errors.pass)} />
                                <button className="workplace-password-toggle" type="button" onClick={() => this.setState({ showPassword: !showPassword })} aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'}>
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                            <p className="workplace-field-error" role="alert">{errors.pass}</p>

                            {isLoginFailed && <p className="workplace-login-error" role="alert">Tài khoản hoặc mật khẩu không hợp lệ.</p>}

                            <button className="workplace-login-button" type="submit" disabled={isSubmitting}>
                                <span className="workplace-shield"><ShieldCheck size={15} /></span>
                                {isSubmitting ? 'Đang đăng nhập...' : 'Đăng nhập Workplace'}
                                <ArrowRight className="workplace-button-arrow" size={19} />
                            </button>

                            <div className="workplace-trust-note">
                                <LockKeyhole size={19} aria-hidden="true" />
                                <p><strong>Kết nối bảo mật</strong><br />Tài khoản và quyền truy cập được quản lý tập trung.</p>
                            </div>
                        </form>

                        <p className="workplace-login-help">Cần hỗ trợ truy cập? <a href="mailto:cntt-thagrico@thagrico.vn">Liên hệ Ban CNTT THACO AGRI</a></p>
                        <p className="workplace-login-copyright">Copyright © 2025 THACO AGRI<br /><strong>Phát triển bởi Ban CNTT THACO AGRI</strong></p>
                    </section>
                </section>
            </main>
        );
    }
}

export default LoginPage;
